import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const SmsSupport = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-gray-100 text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  {" "}
                  💬 Proactive SMS Support for Healthcare – By{" "}
                </span>
                <span className="text-blue-600"> Right On Time Services </span>
              </h1>
              <p className="mt-4 mb-4 font-bold">
                Streamline Your Medical Practice with Smart, Secure, and
                Seamless Communication
              </p>
              <p className="text-white mb-8">
                Managing a healthcare business comes with countless
                challenges—but communication shouldn’t be one of them. At Right
                On Time Services, we offer dedicated 24/7 SMS support tailored
                to simplify medical consultations, improve efficiency, and
                elevate patient satisfaction.
              </p>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Meet Us */}
      <section className="py-16 text-center bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900">
          🤝 Meet Your Reliable Communication Partner
        </h2>
        <p className="mt-4 px-8 max-w-4xl mx-auto">
          Our SMS support team is more than just a messaging service—we’re a
          vital extension of your medical operations. With around-the-clock
          availability, we help clinics, hospitals, and consultants stay
          connected to their patients in real time. Whether it's scheduling,
          prescriptions, or billing, we handle the communication, so you can
          focus on delivering excellent care.
        </p>
      </section>

      <section className="py-16 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          📲 What We Offer: SMS Support Services for Medical Providers
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📅 Appointment Scheduling Made Effortless
            </h3>
            <p className="mt-2">
              Missed appointments are costly—for both patients and practices. We
              provide:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Automated reminders for upcoming visits</li>
              <li>● Rescheduling assistance</li>
              <li>● Personalized pre-visit information</li>
            </ul>
            <p className="mt-2">
              Our service helps reduce no-shows and ensures your patients stay
              informed and on time.
            </p>
          </motion.div>

          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              💊 Prescription Management That Promotes Adherence
            </h3>
            <p className="mt-2">
              Patient safety starts with medication compliance. Our SMS
              reminders support:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Timely medication intake</li>
              <li>● Instructions on dosages and side effects</li>
              <li>● Prescription refill coordination</li>
            </ul>
            <p className="mt-2">
              We help ensure your patients follow treatment plans consistently
              and confidently.
            </p>
          </motion.div>

          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              💳 Billing & Payment Notifications
            </h3>
            <p className="mt-2">
              Simplify your financial processes with proactive communication. We
              provide:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● SMS alerts for payment due dates</li>
              <li>● Billing summaries and transaction confirmations</li>
              <li>● Quick responses to billing queries</li>
            </ul>
            <p className="mt-2">
              Patients stay informed, and you get faster payments with fewer
              disputes.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              ℹ️ General Inquiries – Handled with Care
            </h3>
            <p className="mt-2">
              From clinic hours to available services, we manage everyday
              questions so you don’t have to. Our SMS support also covers:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Basic service details</li>
              <li>● Appointment booking support</li>
              <li>● Staff credentials and facility information</li>
            </ul>
            <p className="mt-2">
              A knowledgeable assistant is just a text away for your patients.
            </p>
          </motion.div>
        </div>
      </section>

      <motion.div
        className="p-6  bg-gray-50 rounded-lg transition duration-300"
        whileHover={{ scale: 1.05 }}
        data-aos="fade-up"
      >
        <section className="py-20 bg-gray-50 px-4 md:px-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-blue-700 mb-6">
              🌟 Why Choose Right On Time Services for SMS Support?
            </h2>
            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 justify-items-center">
              <div className="bg-white p-6 rounded-2xl shadow-md w-full max-w-sm text-left">
                <h4 className="text-xl font-semibold text-blue-800 mb-2">
                  ✅ 24/7 Availability
                </h4>
                <p className="text-gray-700 text-sm">
                  We’re always online—so your patients never feel ignored.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-md w-full max-w-sm text-left">
                <h4 className="text-xl font-semibold text-blue-800 mb-2">
                  ✅ Automated, Yet Personalized
                </h4>
                <p className="text-gray-700 text-sm">
                  From reminders to rescheduling, our automated tools still feel
                  human.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-md w-full max-w-sm text-left">
                <h4 className="text-xl font-semibold text-blue-800 mb-2">
                  ✅ Healthcare-Focused
                </h4>
                <p className="text-gray-700 text-sm">
                  We understand medical workflows and patient needs deeply.
                </p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-md w-full max-w-sm text-left">
                <h4 className="text-xl font-semibold text-blue-800 mb-2">
                  ✅ Secure & Compliant
                </h4>
                <p className="text-gray-700 text-sm">
                  We prioritize patient privacy and adhere to healthcare data
                  standards.
                </p>
              </div>
            </div>
          </div>
        </section>
      </motion.div>

      <motion.section
        className="py-16 text-center bg-white rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        data-aos="fade-up"
      >
        <section className="py-20 bg-white px-4 md:px-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-blue-700 mb-6">
              🚀 Elevate Your Medical Consultancy Today
            </h2>
            <p className="text-gray-700 text-md mb-4">
              Efficient communication is key to outstanding care. Our SMS
              support service helps you reduce admin workload, boost patient
              engagement, and ensure continuity of care.
            </p>
            <p className="text-lg font-semibold text-blue-800">
              📞 Let’s connect — discover how Right On Time Services can
              transform your patient communication.
            </p>
          </div>
        </section>
      </motion.section>
    </div>
  );
};

export default SmsSupport;
